import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { MEDCONNECT_AGENT_BASE_PATH } from './MedConnectAgentChatPage'

/**
 * Legacy `/medconnect-admin-agent` route. Agent types are collapsed into the single ELARA
 * orchestrator (admin tools are granted server-side from the user's roles), so this is now an
 * alias of the normal chat page. Kept so bookmarks and the sidebar entry keep working.
 */
export function MedConnectAdminAgentPage() {
    const { sessionId } = useParams<{ sessionId?: string }>()
    const target = sessionId ? `${MEDCONNECT_AGENT_BASE_PATH}/${sessionId}` : MEDCONNECT_AGENT_BASE_PATH
    return <Navigate to={target} replace />
}
